import React, { PureComponent } from "react";
import { Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import html2canvas from "html2canvas";
import { downloadCSVData, downloadCanvasWithTitle, getViewConversationDuration } from "../utils";
import * as d3 from "d3";
import moment from "moment-timezone";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import OverallShareOfVoiceChart from "./OverallShareOfVoiceChart";
import NoData from "../NoData/NoData";
import IntervalSelector from "../IntervalSelector";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import DownloadChart from "../DownloadChart";

import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";

import { ReactComponent as ComparisionIcon } from "../../../../../assets/svg/CompareChartIcon.svg";
class OverallShareOfVoice extends PureComponent {
    constructor(props) {
        super(props);
        this.selectedTopic = null;
        this.state = {
            downloading: false,
            aggs_val: "default",
        };
        this.chartEl = React.createRef();
    }

    componentDidUpdate(prevProps) {
        // if (prevProps.graph_type !== this.props.graph_type && this.props.graph_type === "line" && this.props.data && !this.props.data.chartDataLine) {
        //     this.props.changeGraphType("line", true);
        // }
    }

    downloadTopicsOverallCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        console.log("csvData", this.props.data.csvData[0]);
        let csvFmt;
        let comparisonCsvFmt;
        if (this.props.graph_type === "line") {
            let userTz = JSON.parse(localStorage.getItem("company")).user_timezone_name;
            csvFmt = [["Time"]];
            this.props.data.csvData[0].data.forEach((d) => {
                csvFmt.push([moment(d.x).tz(userTz).format("YYYY-MM-DD HH:mm")]);
            });
            this.props.data.csvData.forEach((t) => {
                csvFmt[0].push(t.name);
                t.data.forEach((d, i) => {
                    csvFmt[i + 1].push(d.y);
                });
            });

            if (this.props.comparisionData && this.props.comparisionData.csvData[0].data) {
                comparisonCsvFmt = [[" Comparison Time"]];
                let topic = this.props.comparisionData.csvData[0].data;
                this.props.comparisionData.csvData[0].data.forEach((d) => {
                    comparisonCsvFmt.push([moment(d.x).tz(userTz).format("YYYY-MM-DD HH:mm")]);
                });
                this.props.comparisionData.csvData.forEach((t) => {
                    comparisonCsvFmt[0].push(t.name);
                    t.data.forEach((d, i) => {
                        comparisonCsvFmt[i + 1].push(d.y);
                    });
                });

                csvFmt.push(...comparisonCsvFmt);
                let firstIndLen = csvFmt[0].length;
                let lastIndLen = csvFmt[csvFmt.length - 1].length;

                let length;
                if (firstIndLen > lastIndLen) length = firstIndLen;
                else length = lastIndLen;

                let arr = [];
                for (let i = 0; i < length; i++) {
                    arr.push([]);
                    for (let j = 0; j < csvFmt.length; j++) {
                        if (csvFmt[j] && csvFmt[j][i]) arr[i].push(csvFmt[j][i]);
                        else arr[i].push(0);
                    }
                }
                csvFmt = arr;
            }
        } else {
            csvFmt = [["Topic", "Value"]];
            this.props.data.csvData.forEach((topic, index) => {
                csvFmt.push([topic.name, topic.value]);
            });
        }
        downloadCSVData(csvFmt, this.props.widget.name);
    };

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadTopicsOverallCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        html2canvas(this.chartEl.current, { backgroundColor: options.background ? "#fff" : null }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });
        contextMenu
            .append("li")
            .text("View Insights")
            .on("click", () => {
                // console.log('drilldown')
                self.handleDrilldownClick(chart);
                // this.props.showChartsDrilldown(true, "overallShareOfVoice");
            });
        contextMenu.style("display", "block");
    };

    createNewFilter(d) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};

        if (this.props.graph_type === "pie") {
            if (d.options.allSubtopicSelected === "others") {
                newFilter.topics = d.options.topicIds;
                newFilter.subtopics = d.options.subtopicIds;
            } else if (d.options.allSubtopicSelected) {
                newFilter.topics = [d.options.topicId];
                newFilter.subtopics = [];
            } else {
                newFilter.topics = [];
                newFilter.subtopics = d.options.subtopicIds;
            }
        } else if (this.props.graph_type === "bar") {
            if (d.series.userOptions.allSubtopicSelected === "others") {
                newFilter.topics = d.series.userOptions.topicIds;
                newFilter.subtopics = d.series.userOptions.subtopicIds;
            } else if (d.series.userOptions.allSubtopicSelected) {
                newFilter.topics = [d.series.userOptions.topicId];
                newFilter.subtopics = [];
            } else {
                newFilter.topics = [];
                newFilter.subtopics = d.series.userOptions.subtopicIds;
            }
        } else if (this.props.graph_type === "line") {
            if (d.series.userOptions.allSubtopicSelected === "others") {
                newFilter.topics = d.series.userOptions.topicIds;
                newFilter.subtopics = d.series.userOptions.subtopicIds;
            } else if (d.series.userOptions.allSubtopicSelected) {
                newFilter.topics = [d.series.userOptions.topicId];
                newFilter.subtopics = [];
            } else {
                newFilter.topics = [];
                newFilter.subtopics = d.series.userOptions.subtopicIds;
            }

            let lastComparisonIndex = false;
            lastComparisonIndex = d.index === d.series.points.length - 1 && d.color.endsWith("55");

            newFilter = getViewConversationDuration(
                d,
                newFilter,
                this.props.aggs_val,
                this.props.filters,
                this.props.comparisionData,
                lastComparisonIndex,
                this.props.comparisonAppliedFilter,
            );
        }
        return newFilter;
    }

    handleContextMenuClick = (d) => {
        let newFilter = this.createNewFilter(d);
        this.props.handleContextMenuClick(newFilter);
    };

    handleDrilldownClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleDrilldownClick(newFilter);
    }

    changeGraphType = (val) => {
        let makeApiCall = val === "line" && ["bar", "pie"].includes(this.props.graph_type) && !this.props.data.chartDataLine;
        this.props.changeGraphType(val, makeApiCall);
    };

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="This chart provides Share of Voice for the topics you have selected in the filters. This chart uses volume of conversations to determine SOV."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!nodata && (
                            <div className="chart-type">
                                <span onClick={() => this.changeGraphType("pie")} className={this.props.graph_type === "pie" ? "active-chart" : ""}>
                                    <Icon name="pie chart" />
                                </span>
                                <span onClick={() => this.changeGraphType("bar")} className={this.props.graph_type === "bar" ? "active-chart" : ""}>
                                    <Icon name="bar chart" />
                                </span>
                                <span onClick={() => this.changeGraphType("line")} className={this.props.graph_type === "line" ? "active-chart" : ""}>
                                    <Icon name="line chart" />
                                </span>
                            </div>
                        )}
                        {!this.props.isResearchDashboard &&
                            this.props.graph_type !== "pie" &&
                            this.props.graph_type !== "bar" &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <Popup
                                    content="Chart Comparison Filters"
                                    position="bottom center"
                                    size="tiny"
                                    inverted
                                    className="skiptranslate"
                                    trigger={
                                        <div className={`chart-header-icon`} onClick={() => (!this.props.isPublic ? this.props.chartComparision() : null)}>
                                            <ComparisionIcon className={`comparision-filter${this.props.chartComparisionFilterApplied ? "-applied" : ""}`} />
                                        </div>
                                    }
                                />
                            )}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && <>{this.renderDownloadButton(nodata)}</>}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && this.props.graph_type !== "line" && (
                            <CustomCheckBox checked={this.props.showLabel} onClick={this.props.changeShowLabel} label="Show Labels" />
                        )}
                        {!nodata && <CustomCheckBox checked={!this.props.hideCommonLegend} onClick={this.props.changehideCommonLegend} label="Show Legends" />}
                        {!nodata && (this.props.graph_type === "bar" || this.props.graph_type === "line") && (
                            <CustomCheckBox label="Show Grid Lines" checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} />
                        )}
                        {!nodata && this.props.graph_type === "line" && (
                            <IntervalSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleIntervalChange={this.props.handleIntervalChange}
                                disableComparisonInterval={this.props.disableComparisonInterval}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                    {/* {this.props.graph_type !== "pie" && this.props.graph_type !== "bar" && (
                                    <div className="clone-chart menu-option" onClick={this.props.chartComparision}>
                                        <span>Chart Comparision</span>
                                        <CloneIcon />
                                    </div>
                                )} */}
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart skiptranslate" ref={this.chartEl}>
                        <OverallShareOfVoiceChart
                            graph_type={this.props.graph_type}
                            data={this.props.data}
                            addContextMenuListener={this.addContextMenuListener}
                            showLabel={this.props.showLabel}
                            showLegend={!this.props.hideCommonLegend}
                            // showLegend={this.props.showLegend}
                            showGridLines={this.props.showGridLines}
                            resizedCount={this.props.resizedCount}
                            comparisionData={this.props.comparisionData}
                            // resizedCount={this.props.resizedCount}
                            widgetContainerRef={this.props.widgetContainerRef}
                            legendClick={this.props.legendClick}
                            expandWidget={this.props.expandWidget}
                        />
                        {/* {this.state.downloading && <DimmerComponent />} */}
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        allTopics: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.topics : [],
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OverallShareOfVoice);
